import * as React from 'react';
import { MultipleFocus } from '../../core/Focus';
import { Entry, Layout, Plugin } from './slots';
import { SelectProps } from './types';

import Select from './Select';

const Component: React.FunctionComponent<SelectProps> = ({ children, ...props }) => {
    return (
        <Entry connectLayout={children}>
            <Select {...props}>
                <MultipleFocus>
                    <Layout name="control" />
                    <Layout name="dropdown" />
                    <Plugin />
                </MultipleFocus>
            </Select>
        </Entry>
    );
};

export default Component;
